import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import * as actions from "../../../actions";

import Companies from "./companies";
import Details from "./details";
import Sidebar from "./sidebar";
import { COWORKERCOMPANY_RESPONSE } from "../../../constants/action_types";
import moment from "moment";
import Activity from "../../../components/activitiy";
import { UserAvatar } from "../../../components/user_avatar";

function CoworkerDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { coworker_uid, type: pageType } = useParams();
  const [type, setType] = useState();

  const coworkerDetails = useSelector(
    (state) => state.coworker?.details?.coworker
  );

  useEffect(() => {
    if (coworker_uid) {
      dispatch(actions.GETCOWORKER_REQ({ coworker_uid }));
    }
  }, [coworker_uid]);

  useEffect(() => {
    if (pageType) setType(pageType);
  }, [pageType]);

  const pageHandling = (type) => {
    navigate(`../${type}`);
    // window.history.pushState(
    //   undefined,
    //   undefined,
    //   `/v2/coworkers/${coworker_uid}/${type}`
    // );
    setType(type);
  };

  return (
    <main class="-mt-24">
      <div class="mx-auto max-w-[86rem] py-3 sm:px-6 lg:px-8">
        <div class="flex flex-1 h-full space-x-4">
          <aside class="w-80 min-h-[535px] mt-3 overflow-y-auto rounded-lg self-start sticky top-4">
            <div class="shadow p-4 bg-white">
              <div class="relative">
                <div class="relative flex items-center space-x-3 py-2">
                  <div class="flex-shrink-0">
                    {/* <img
                      class="h-10 rounded-full"
                      src={coworkerDetails?.profile_pic || ""}
                      alt=""
                    /> */}
                    <UserAvatar user={coworkerDetails} />
                  </div>
                  <div class="min-w-0 flex-1">
                    <p class="text-lg font-medium text-gray-900">
                      {coworkerDetails?.name || "...."}
                    </p>
                    <p class="truncate text-xs text-gray-500">
                      Created{" "}
                      {coworkerDetails?.created_at
                        ? moment(coworkerDetails?.created_at).format(
                            "DD MMM, YYYY"
                          )
                        : "...."}
                    </p>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <Sidebar
                coworker_uid={coworker_uid}
                type={type}
                pageHandling={pageHandling}
              ></Sidebar>
            </div>
          </aside>

          <section class="flex flex-1 min-w-0 flex-col lg:order-last">
            {type === "details" ? (
              <Details
                coworker_uid={coworker_uid}
                coworkerDetails={coworkerDetails}
              ></Details>
            ) : type === "companies" ? (
              <Companies
                coworker_uid={coworker_uid}
                coworkerDetails={coworkerDetails}
              ></Companies>
            ) : type === "activity" ? (
              <Activity uid={coworker_uid} type="COWORKER"></Activity>
            ) : (
              <></>
            )}
          </section>
        </div>
      </div>
    </main>
  );
}

export default CoworkerDetails;
